/* eslint-disable max-nested-callbacks, max-lines, max-statements, require-jsdoc */
// @flow
/**
 * !!!DEPRECATED LIBS!!!
 */
import isLength from 'validator/lib/isLength';
import isEmail from 'validator/lib/isEmail';
import isNumeric from 'validator/lib/isNumeric';

import type {AuthorizationType, AuthorizationErrorsValidationType} from 'constants/flow/flowTypes';

/**
 * Validation for authorization forgot
 */
export class ValidationAuthorizationLogin {
    fields: {
        email: string,
        password: string,
    };
    rules: {
        email: (value: string) => string,
        password: (value: string) => string,
    };

    /**
     * Constructor
     * @param {{email: string, password: string}} fields all payment fields
     */
    constructor(fields: {email: string, password: string}) {
        this.rules = {
            email: (value: string): string => {
                if (!isLength(value.trim(), {min: 1})) return 'Required';
                if (!isEmail(value)) return 'Invalid field';
                return 'success';
            },
            password: (value: string): string => {
                if (!isLength(value.trim(), {min: 6})) return 'Required';
                return 'success';
            },
        };
        this.fields = fields;
    }

    /**
     * Validate one field(needed for input,select etc components)
     * @param {string} field - field
     * @returns {boolean} result validation
     */
    one = (field: string): string => this.rules[field](this.fields[field]);
}

/**
 * Validation for authorization register
 */
export class ValidationAuthorizationRegister {
    fields: AuthorizationType;
    rules: AuthorizationErrorsValidationType;

    /**
     * Constructor
     * @param {AuthorizationType} fields all payment fields
     */
    constructor(fields: AuthorizationType) {
        this.rules = {
            firstName: (value: string): string => {
                if (!isLength(value.trim(), {min: 1, max: 40})) return 'Required';
                if (isNumeric(value.trim())) return 'Invalid field';
                return 'success';
            },
            lastName: (value: string): string => {
                if (!isLength(value.trim(), {min: 1, max: 40})) return 'Required';
                if (isNumeric(value.trim())) return 'Invalid field';
                return 'success';
            },
            email: (value: string): string => {
                if (!isLength(value.trim(), {min: 1})) return 'Required';
                if (!isEmail(value)) return 'Invalid field';
                return 'success';
            },
            password: (value: string): string => {
                if (!isLength(value.trim(), {min: 6})) return 'Required';
                return 'success';
            },
            isAgreedPrivacyPolicy: (value: boolean): string => {
                if (value === false)
                    return 'Please agree to the privacy policy to complete your signup';
                return 'success';
            },
            isSubscribed: (): string => {
                return 'success';
            },
        };
        this.fields = fields;
    }

    /**
     * Validate one field(needed for input,select etc components)
     * @param {string} field - field
     * @returns {boolean} result validation
     */
    one = (field: string): string => this.rules[field](this.fields[field]);

    /**
     * Validate all fields
     * @returns {any} result validations
     */
    all = (): any => {
        const result = {};
        Object.keys(this.fields).map(
            (value: string) => (result[value] = this.rules[value](this.fields[value])),
        );
        return result;
    };
}

/**
 * Validation for authorization forgot
 */
export class ValidationAuthorizationForgot {
    fields: {email: string};
    rules: {email: (value: string) => string};

    /**
     * Constructor
     * @param {{email: string}} fields all payment fields
     */
    constructor(fields: {email: string}) {
        this.rules = {
            email: (value: string): string => {
                if (!isLength(value.trim(), {min: 1})) return 'Required';
                if (!isEmail(value)) return 'Invalid field';
                return 'success';
            },
        };
        this.fields = fields;
    }

    /**
     * Validate one field(needed for input,select etc components)
     * @param {string} field - field
     * @returns {boolean} result validation
     */
    one = (field: string): string => this.rules[field](this.fields[field]);
}
